<template>

  <div>
    <div class="autocomplete d-flex align-center">
      <v-combobox :value="_value"
                  @input="change($event)"
                  :items="items"
                  :label="_label"
                  :menu-props="{ auto: true }"
                  :multiple="multiple"
                  :chips="multiple"
                  :small-chips="multiple"
                  :deletable-chips="multiple"
                  item-text="name"
                  item-value="code"
      />

      <div class="icon" v-if="value">
        <v-btn text icon @click="clear()" v-if="clearable">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'issue-codes-select',

    props: [ 'value', 'label', 'clearable', 'multiple' ],

    data () {
      return {
        items: []
      }
    },

    computed: {
      _label () {
        return this.label || this.$t('entityNames.issue-codes')
      },

      _value () {
        return this.items.find(x => x.code === this.value) || this.value
      }
    },

    methods: {
      change (value) {
        value = value && value.code ? value.code : value

        this.$emit('input', value)
        this.$emit('change', value)
      },

      clear () {
        this.$emit('input', null)
      }
    },

    async created () {
      this.items = await this.$store.dispatch('getStaticItems', { model: { name: 'issue-codes' } })
    },
  }

</script>

<style lang="scss" scoped>

</style>
